import { baseApi } from "@/lib/axios";
import { NETWORK_API } from "./url";
import { Network } from "@/model";
import axiosServer from "../../lib/axios-server";

export function getNetworks({ status }: { status: any }) {
  return baseApi<Network[]>({
    url: NETWORK_API.urlCartList,
    method: "GET",
    params: {
      isDeleted: status,
    },
  });
}

export function getServerSideNetworks({ status }: { status: any }) {
  return axiosServer({
    url: NETWORK_API.urlCartList,
    method: "GET",
    params: {
      isDeleted: status,
    },
  });
}
